import * as React from 'react';
import { Pagination as MuiPagination } from '@material-ui/lab';

var Pagination = function Pagination(_ref) {
  var a11yLabel = _ref.a11yLabel,
      count = _ref.count,
      disabled = _ref.disabled,
      dsOnChange = _ref.dsOnChange,
      showFirstButton = _ref.showFirstButton,
      showLastButton = _ref.showLastButton,
      defaultPage = _ref.defaultPage;
  return /*#__PURE__*/React.createElement(MuiPagination, {
    "aria-label": a11yLabel,
    color: "primary",
    count: count,
    defaultPage: defaultPage,
    disabled: disabled,
    onChange: dsOnChange,
    shape: "rounded",
    showFirstButton: showFirstButton,
    showLastButton: showLastButton
  });
};

export default Pagination;

try {
  Pagination.__docgenInfo = {
    description: '',
    displayName: 'Pagination',
    methods: [],
    props: {
      a11yLabel: {
        defaultValue: null,
        description: "By default, value is 'pagination navigation'. Optionally, override with a custom value.",
        name: 'a11yLabel',
        required: false,
        type: {
          name: 'string'
        }
      },
      dsOnChange: {
        defaultValue: null,
        description: '',
        name: 'dsOnChange',
        required: false,
        type: {
          name: '(event: ChangeEvent<unknown>, page: number) => void'
        }
      },
      disabled: {
        defaultValue: {
          value: 'false'
        },
        description: 'If `true`, the pagination component will be disabled.',
        name: 'disabled',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      count: {
        defaultValue: {
          value: '1'
        },
        description: 'The total number of pages.',
        name: 'count',
        required: false,
        type: {
          name: 'number'
        }
      },
      defaultPage: {
        defaultValue: {
          value: '1'
        },
        description: 'The page selected by default when the component is uncontrolled.',
        name: 'defaultPage',
        required: false,
        type: {
          name: 'number'
        }
      },
      showFirstButton: {
        defaultValue: {
          value: 'false'
        },
        description: 'If `true`, show the first-page button.',
        name: 'showFirstButton',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      showLastButton: {
        defaultValue: {
          value: 'false'
        },
        description: 'If `true`, show the last-page button.',
        name: 'showLastButton',
        required: false,
        type: {
          name: 'boolean'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map